import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _find from "lodash/find";
import _memoize from "lodash/memoize";
/* eslint import/no-webpack-loader-syntax: 0, import/no-unresolved: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LogoUSA from './logos/LogoUSA';
import LogoCanada from './logos/LogoCanada';

var DEFAULT_LOGO = function DEFAULT_LOGO() {
  return React.createElement("path", {
    fill: "#FFFFFE",
    d: "M16.6,0.2H0.4C0.2,0.2,0,0.3,0,0.6v26.8c0,0.7,0.4,0.8,0.9,0.4l2.5-2.4l3.2-3.1c0.1-0.1,0.3-0.1,0.4-0.1h9.8 c5.9,0,10.5-5.1,10.5-10.9C27.2,5.3,22.5,0.2,16.6,0.2z M5.5,5.8c0-0.1,0.1-0.2,0.2-0.2h12.9c0.1,0,0.2,0.1,0.2,0.2v1.6 c0,0.1-0.1,0.2-0.2,0.2H5.8c-0.1,0-0.2-0.1-0.2-0.2V5.8z M18.9,16.3c0,0.1-0.1,0.2-0.2,0.2H5.8c-0.1,0-0.2-0.1-0.2-0.2v-1.6 c0-0.1,0.1-0.2,0.2-0.2h12.9c0.1,0,0.2,0.1,0.2,0.2V16.3z M21.6,11.9c0,0.1-0.1,0.2-0.2,0.2H5.8c-0.1,0-0.2-0.1-0.2-0.2v-1.6 c0-0.1,0.1-0.2,0.2-0.2h15.6c0.1,0,0.2,0.1,0.2,0.2V11.9z"
  });
};

var logos = [{
  name: 'usa',
  display: function display(countryCode) {
    if (countryCode !== 'US') return false;
    var today = new Date();
    if (today.getMonth() !== 6) return false;
    if (today.getDate() > 8) return false;
    return true;
  },
  logo: LogoUSA
}, {
  name: 'canada',
  display: function display(countryCode) {
    if (countryCode !== 'CA') return false;
    var today = new Date();
    if (today.getMonth() !== 6) return false;
    if (today.getDate() > 8) return false;
    return true;
  },
  logo: LogoCanada
}];

var getCountryCodeFromAddress = _memoize(function (address) {
  if (/(USA|United States|United States of America)$/i.test(address)) return 'US';
  if (/(Canada|CA)$/i.test(address)) return 'CA';
  return null;
});

var Logo =
/*#__PURE__*/
function (_Component) {
  _inherits(Logo, _Component);

  function Logo(props) {
    var _this;

    _classCallCheck(this, Logo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Logo).call(this, props));
    _this.state = {};
    return _this;
  }

  _createClass(Logo, [{
    key: "getCountryCode",
    value: function getCountryCode() {
      var currentLocation = this.props.currentLocation;
      return getCountryCodeFromAddress(currentLocation.address);
    }
  }, {
    key: "getLogo",
    value: function getLogo() {
      var _this2 = this;

      var _this$props = this.props,
          logo = _this$props.logo,
          dynamic = _this$props.dynamic;

      if (logo) {
        var propsLogo = _find(logos, function (searchLogo) {
          return searchLogo.name === logo;
        });

        if (propsLogo && propsLogo.logo) return propsLogo.logo;
      }

      if (dynamic) {
        var foundLogo = _find(logos, function (searchLogo) {
          return searchLogo.display(_this2.getCountryCode());
        });

        if (foundLogo && foundLogo.logo) return foundLogo.logo;
      }

      return DEFAULT_LOGO;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          hideText = _this$props2.hideText,
          textOnly = _this$props2.textOnly,
          textColor = _this$props2.textColor;
      var viewBox = '0 0 160 45';
      var textStyle = {};
      var imageStyle = {};
      var logo = this.getLogo();
      textStyle.fill = textColor;

      if (hideText) {
        textStyle.display = 'none';

        if (logo === DEFAULT_LOGO) {
          viewBox = '0 0 28 28';
        } else {
          viewBox = '0 0 45 45';
        }
      } else if (textOnly) {
        imageStyle.display = 'none';
        viewBox = '51 7 110 21';
      }

      return React.createElement("svg", {
        viewBox: viewBox,
        xmlns: "http://www.w3.org/2000/svg"
      }, React.createElement("title", null, "Podium"), React.createElement("g", null, React.createElement("path", {
        style: textStyle,
        d: "M59.925 18.23c1.634 0 2.45-.433 3.018-1.097.532-.63.816-1.414.816-2.317 0-.903-.29-1.727-.82-2.357-.57-.67-1.39-1.1-3.02-1.1h-3.98c-.2 0-.35.15-.35.35v6.17c0 .19.16.35.35.35h3.98zm-4.332 3.29v5.38c0 .192-.158.35-.35.35H52.22c-.194 0-.352-.158-.352-.35V8.422c0-.19.158-.35.352-.35h7.55c2.938 0 4.667.714 5.94 2.042 1.143 1.166 1.796 2.915 1.796 4.7 0 1.78-.653 3.528-1.796 4.695-1.24 1.29-3.002 2.01-5.94 2.01h-4.177zm23.947 2.716c3.642 0 6.347-2.96 6.347-6.575 0-3.61-2.705-6.57-6.348-6.57s-6.35 2.96-6.35 6.58 2.7 6.58 6.34 6.58zm0-16.437c5.96 0 10.072 4.4 10.072 9.86 0 5.45-4.112 9.86-10.073 9.86-5.96 0-10.08-4.41-10.08-9.87 0-5.456 4.11-9.86 10.07-9.86zm19.43 16.16c2.29 0 3.862-.8 4.94-2.14.882-1.1 1.404-2.57 1.404-4.17 0-1.59-.522-3.07-1.405-4.16-1.08-1.348-2.65-2.14-4.94-2.14h-2.41c-.2 0-.35.154-.35.35v11.9c0 .19.15.35.35.35h2.41zm-.415 3.28h-5.72c-.193 0-.35-.16-.35-.35V8.42c0-.19.157-.35.35-.35h5.72c3.062 0 5.078.66 6.65 1.81 2.373 1.75 3.836 4.602 3.836 7.78 0 3.176-1.46 6.027-3.83 7.78-1.57 1.15-3.59 1.807-6.65 1.807zm13.68-18.83c0-.196.157-.35.35-.35h3.023c.193 0 .35.154.35.35V26.9c0 .19-.157.35-.35.35h-3.022c-.194 0-.352-.16-.352-.35V8.422m8 10.745V8.422c0-.19.158-.35.352-.35h3.022c.193 0 .352.16.352.35v11.02c0 1.754.47 2.82 1.27 3.56.826.795 1.985 1.234 3.283 1.234 1.296 0 2.455-.44 3.284-1.233.8-.74 1.27-1.807 1.27-3.56V8.423c0-.192.157-.35.35-.35h3.022c.19 0 .35.158.35.35v10.744c0 2.933-.89 4.958-2.49 6.384-1.49 1.32-3.62 1.98-5.8 1.98-2.18 0-4.307-.66-5.796-1.97-1.6-1.42-2.484-3.45-2.484-6.38m29.813-3.193c.115.153.31.153.424 0l5.83-7.6c.118-.154.37-.28.566-.28h2.697c.193 0 .35.16.35.35V26.93c0 .192-.16.35-.35.35h-3.02c-.194 0-.352-.158-.352-.35V14.92c0-.19-.096-.223-.213-.07l-5.51 7.143c-.117.15-.31.15-.427 0l-5.504-7.15c-.12-.15-.216-.12-.216.073V26.92c0 .193-.16.35-.35.35h-3.02c-.196 0-.35-.157-.35-.35V8.444c0-.192.154-.35.35-.35h2.695c.19 0 .445.126.562.28l5.83 7.6",
        fill: "#333333"
      })), React.createElement("g", {
        style: imageStyle
      }, logo()));
    }
  }]);

  return Logo;
}(Component);

_defineProperty(Logo, "propTypes", {
  currentLocation: PropTypes.shape({
    address: PropTypes.string,
    phone: PropTypes.string
  }),
  dynamic: PropTypes.bool,
  hideText: PropTypes.bool,
  logo: PropTypes.string,
  textColor: PropTypes.string,
  textOnly: PropTypes.bool
});

_defineProperty(Logo, "defaultProps", {
  currentLocation: {},
  dynamic: false,
  hideText: false,
  logo: null,
  textColor: '#333',
  textOnly: false
});

export { Logo as default };